import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Text } from '../../components/Text';
import { Button, Col, Row, Pagination, Modal } from 'react-bootstrap';
import { Subtitle } from '../../components/SubTitle';
import Search from '../../components/Search';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { FillPen, FillPlus } from '../../components/Icons';
import { Title } from '../../components/Title';
import './style.css';
import AlertMessage from '../../components/Alert';

export function Pagamentos() {
    const [isLoading, setIsLoading] = useState(true);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);

    const [employees, setEmployees] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [employeesPerPage, setEmployeesPerPage] = useState(20);
    const [employeesPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);

    const [searchQuery, setSearchQuery] = useState('');
    const [currentFilteredEmployees, setCurrentFilteredEmployees] = useState([]);

    // Calcula o índice do primeiro e do último funcionário na página atual
    const indexOfLastEmployee = currentPage * employeesPerPage;
    const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;

    const currentEmployees = employees.slice(indexOfFirstEmployee, indexOfLastEmployee);

    const filteredEmployees = employees.filter((employee: any) => {

        const cpfClean = employee.empresa.replace(/[\.-]/g, ''); // Remove '.' e '-'

        return (
            employee.empresa.toLowerCase().includes(searchQuery.toLowerCase()) ||
            cpfClean.includes(searchQuery) ||
            employee.id.toString().includes(searchQuery)
        );
    });
    const [show, setShow] = useState(false);
    const [idSelected, setIdSelected] = useState('');

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
  
    const handleClose = () => setShow(false);

    const showModal = (id: any) => {
        setIdSelected(id)
        setShow(true)
    }
    const handleConfirm = async () => {
      try {
         await api.delete(`empresas/deletar/${idSelected}`);
         const response = await api.get('empresas')
         setEmployees(response.data);
         setAlert({ show: true, message: 'Item excluído com sucesso!', variant: 'success' });
      } catch (error) {
        console.error("Erro ao tentar excluir:", error);
        setAlert({ show: true, message: 'Erro ao excluir item', variant: 'danger' });
      }
      handleClose();
    };

    useEffect(() => {
        const indexOfLastFilteredEmployee = currentPage * employeesPerPage;
        const indexOfFirstFilteredEmployee = indexOfLastFilteredEmployee - employeesPerPage;
        const newCurrentFilteredEmployees = filteredEmployees.slice(indexOfFirstFilteredEmployee, indexOfLastFilteredEmployee);

        setCurrentFilteredEmployees(newCurrentFilteredEmployees);
    }, [currentPage, employeesPerPage, filteredEmployees]);

    // Function to load companies
    const loadCompanies = async () => {
        try {
            const response = await api.get('empresas');
            setCompanies(response.data.message ? [] : response.data);
            setSelectedCompany(response.data.length > 0 ? response.data[0].id : null);
        } catch (error) {
            console.error("Error fetching companies:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const loadEmployees = async (companyId: any) => {
        try {
            const response = await api.get('pagamentos/usuario/listar')
            setEmployees(response.data);
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    const handleEmployeesPerPageChange = (value: any) => {
        setEmployeesPerPage(Number(value));
        setCurrentPage(1); // Volta para a primeira página ao mudar a quantidade por página
    };
    // Load companies initially
    useEffect(() => {
        loadCompanies();
    }, []);

    useEffect(() => {
        loadEmployees(selectedCompany);
    }, [selectedCompany]); // Carregar funcionários quando a empresa selecionada for alterada

    const handleSelectCompany = (id: any) => {
        setSelectedCompany(id);
    };

    const handleStatusChange = async (employeeId: any, currentStatus: any) => {
        const newStatus = currentStatus === true ? false : true;

        try {
            await api.post('status-funcionarios', { id_empresa: selectedCompany, id_funcionario: employeeId, status: newStatus });
            // Reload employees to reflect the change
            loadEmployees(selectedCompany);
        } catch (error) {
            console.error("Error updating employee status:", error);
        }
    };

    // Atualizar a consulta de pesquisa
    const handleSearchChange = (value: string) => {
        setSearchQuery(value);
        setCurrentPage(1);
    };

    /*paginação*/
    const paginationItems = () => {
        let items = [];
        const totalPaginas = Math.ceil(filteredEmployees.length / employeesPerPage); // Use filteredEmployees para calcular o total de páginas

        // Primeira página
        if (currentPage > 2) {
            items.push(
                <Pagination.Item
                    key="first"
                    onClick={() => setCurrentPage(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Reticências antes da página atual, se necessário
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
        }

        // Página anterior à atual, se aplicável
        if (currentPage > 1) {
            items.push(
                <Pagination.Item
                    key={currentPage - 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        // Página atual
        items.push(
            <Pagination.Item
                key={currentPage}
                active
            >
                {currentPage}
            </Pagination.Item>
        );

        // Página seguinte à atual, se aplicável
        if (currentPage < totalPaginas) {
            items.push(
                <Pagination.Item
                    key={currentPage + 1}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        // Reticências depois da página atual, se necessário
        if (currentPage < totalPaginas - 2) {
            items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
        }

        // Última página
        if (currentPage < totalPaginas - 1) {
            items.push(
                <Pagination.Item
                    key="last"
                    onClick={() => setCurrentPage(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            );
        }

        return items;
    };


    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
    

                <CardContent>
                    <Row className='my-4'>
                        <Title text="Pagamentos" />
                    </Row>
                    <Row className='mb-4'>
                        <Col sm={10} className='my-2 d-flex align-items-end'>
                            <span>Página {currentPage} de {Math.ceil(employees.length / employeesPerPage)}</span>

                        </Col>
                        <Col sm={2} className='my-2 d-flex justify-content-end'>
                            <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                {employeesPerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === employeesPerPage}
                                    />
                                ))}
                            </Select>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Table>
                                <THeader>
                                    <ThCell>Plano Comprado</ThCell>
                                    <ThCell>Empresa</ThCell>
                                    <ThCell>Valor</ThCell>
                                    <ThCell>Tipo de Pagamento</ThCell>
                                    <ThCell>Status</ThCell>
                                    <ThCell>Data</ThCell>
                                </THeader>
                                <TBody>
                                    {currentFilteredEmployees.length > 0 ? (
                                        currentFilteredEmployees.map((employee: any) => (
                                            <TGroup key={employee.id}>
                                                <TRow>
                                                    <TCell>{employee.plano_comprado}</TCell>
                                                    <TCell>{employee.empresa}</TCell>
                                                    <TCell>R$ {employee.valor}</TCell>
                                                    <TCell>{employee.tipo_pagamento}</TCell>
                                                    <TCell>{employee.status}</TCell>
                                                    <TCell>{employee.data}</TCell>

                                                </TRow>
                                            </TGroup>
                                        ))
                                    ) : (
                                        <TGroup>
                                            <TRow>
                                                <TCell colSpan={6} className="text-center">
                                                    Não há dados para serem mostrados
                                                </TCell>
                                            </TRow>
                                        </TGroup>
                                    )}

                                </TBody>
                            </Table>
                        </Col>
                        <Col className='d-flex justify-content-center mt-4'>
                            <div className="pagination">
                                <Pagination>
                                    {paginationItems()}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </CardContent>
            </Main>
        </div >
    );
}